var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "activitylist"
  }, [(_vm.showadd == true && _vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting d-sm-down-none",
    on: {
      "click": function($event) {
        _vm.showAddForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg",
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "data-toggle": "tooltip",
      "title": "Add Task"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('activities.activityType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activitytypesearch),
      expression: "activitytypesearch"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('activitytypesearch')
    },
    attrs: {
      "name": "activitytypesearch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activitytypesearch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('activities.activityTypePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listActivitytypeData), function(act_obj) {
    return _c('option', {
      domProps: {
        "value": act_obj.id
      }
    }, [_vm._v("\n                            " + _vm._s(act_obj.activityname))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.asignee')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignee),
      expression: "assignee"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "assignee"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignee = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.AsigneePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.userListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email) + "\n                          ")])
  })], 2)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.statusList')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchstatus",
      "name": "searchstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectStatusList')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created"
    }
  }, [_vm._v("Created")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inprogress"
    }
  }, [_vm._v("Inprogress")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "done"
    }
  }, [_vm._v("Done")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getActivitydatasearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                        " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-6 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('activities.activityList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }), _vm._v(" "), (_vm.selectedList.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-2 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pickerAssignmentShow = true
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('activities.assignUser')) + "\n              ")])]) : _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }), _vm._v(" "), (_vm.resultCount > 0) ? _c('div', {
    staticClass: "col-md-2 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.resultCount))])]) : _vm._e(), _vm._v(" "), (_vm.download && _vm.listActivitydata.length > 0) ? _c('div', {
    staticClass: "col-md-2 mx-5",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton mx-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.handleClick(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1  csv"
  }, [(!_vm.download && _vm.listActivitydata.length) ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.geActivitydata(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.download && _vm.listActivitydata.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter1,
      "title": "Download Excel",
      "data": _vm.ActivityListXls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable my-3",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('activities.activityid')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('activities.activityname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('activities.activityStatus')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.createdDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.createdBy')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('errorLogReport.description')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('activities.estimatedStartDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('activities.estimatedEndDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '' && _vm.warehouseid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientNoWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.clientid == '' && _vm.warehouseid != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.clientid != '' && _vm.warehouseid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.clientid != '' && _vm.warehouseid != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noSearchBtnMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.listActivitydata.length == 0 && _vm.resultCount == 0 && _vm.clientid != '' && _vm.warehouseid != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listActivitydata), function(data) {
    return [_c('tr', {
      staticClass: "text-center "
    }, [_c('td', {
      class: {
        opened: _vm.opened.includes(data.activitydetailsid)
      },
      staticStyle: {
        "padding": "5px",
        "color": "#0000e5",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showRow(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.activitydetailsid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.activityname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.activitystatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.estartdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eenddate))]), _vm._v(" "), _c('td', [(data.activitystatus == 'created') ? _c('span', [_c('a', {
      staticClass: "btn-setting",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showEditForm(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Edit"
      }
    })])]) : _vm._e()])]), _vm._v(" "), (data.contentVisible && _vm.contentVisible) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": 13
      }
    }, [_c('fieldset', {
      staticStyle: {
        "padding": "10px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-14"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('table', {
      staticClass: "table table-bordered mytable12",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', {
      staticClass: "theader"
    }, [_c('tr', {
      staticClass: "prod-list-table"
    }, [_c('th', {
      staticClass: "text-center ",
      attrs: {
        "bind-title": "Select All"
      }
    }, [_c('input', {
      attrs: {
        "title": "Select All Rack",
        "type": "checkbox",
        "id": "parentCheckBox"
      },
      on: {
        "click": _vm.selectAllCheckbox
      }
    })]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('activities.rackIds')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('activities.skuQuantity')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('activities.totalStock')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('activities.scannedStock')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('auditReport.startDate')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('auditReport.endDate')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('orders.assignedTo')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('activities.taskStatus')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('activities.accuracy')) + " %\n                                    "), _c('div', {
      staticClass: "tooltip-container"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "tooltip-element"
    }, [_c('table', [_c('tr', {
      staticStyle: {
        "background-color": "white"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "rgb(64, 155, 224)",
        "width": "8px",
        "border": "none"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.$t('activities.stockScanningMsg')))])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "white"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "red",
        "width": "8px",
        "border": "none",
        "font-size": "5px"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.$t('activities.stockfoundlessmsg')))])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "white"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "yellow",
        "width": "px",
        "border": "none",
        "font-size": "5px"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.$t('activities.sotckfoundmoremsg')))])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "white"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "green",
        "width": "8px",
        "border": "none",
        "font-size": "5px"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.$t('activities.stockMatchedmsg')))])])])])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tasklisting), function(row) {
      return _c('tr', {
        staticClass: "prod-list-table"
      }, [(row.taskstatus == 'assigned' || row.taskstatus == 'created') ? _c('td', {
        staticClass: "text-center ",
        attrs: {
          "scope": "row"
        }
      }, [_c('strong', [_c('input', {
        staticClass: "checkbox1",
        attrs: {
          "title": "Select Rack",
          "type": "checkbox",
          "id": row.rackid
        },
        domProps: {
          "value": row.rackid
        },
        on: {
          "click": function($event) {
            _vm.singleSelected(row)
          }
        }
      })])]) : _c('td', {
        staticClass: "text-center ",
        attrs: {
          "scope": "row"
        }
      }, [_c('input', {
        staticClass: "checkbox1",
        attrs: {
          "disabled": "true",
          "title": "Can't Select ",
          "type": "checkbox"
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.rackid))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.skucount))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.whrackstock))]), _vm._v(" "), (row.physicalstock) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.physicalstock))]) : _vm._e(), _vm._v(" "), (!row.physicalstock) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v("N/A")]) : _vm._e(), _vm._v(" "), (row.actualstartdate) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.actualstartdate))]) : _vm._e(), _vm._v(" "), (!row.actualstartdate) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v("N/A")]) : _vm._e(), _vm._v(" "), (row.actualenddate) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.actualenddate))]) : _vm._e(), _vm._v(" "), (!row.actualenddate) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v("N/A")]) : _vm._e(), _vm._v(" "), (row.userid) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.assignedto))]) : _vm._e(), _vm._v(" "), (!row.userid) ? _c('td', {
        staticClass: "text-center"
      }, [_vm._v("Not Assigned")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.taskstatus))]), _vm._v(" "), (row.percentage == 100 && row.taskstatus == 'done') ? _c('td', [_c('progress-bar', {
        staticClass: "mx-3",
        attrs: {
          "options": _vm.options,
          "value": row.percentage
        }
      })], 1) : _vm._e(), _vm._v(" "), (row.taskstatus == 'done' && row.percentage != 100) ? _c('td', [_c('progress-bar', {
        staticClass: "mx-3",
        attrs: {
          "options": (row.percentage < 100 && !(row.whrackstock == 0 && row.physicalstock > 0)) ? _vm.options1 : (row.whrackstock > 0 && row.physicalstock > 0 && row.percentage < 100) ? _vm.options1 : _vm.options2,
          "value": row.whrackstock > 0 ? Math.abs(((row.physicalstock - row.whrackstock) * 100) / row.whrackstock).toFixed(2) : row.physicalstock * 100
        }
      })], 1) : _vm._e(), _vm._v(" "), (row.percentage && row.taskstatus != 'done') ? _c('td', [_c('progress-bar', {
        staticClass: "mx-3",
        attrs: {
          "options": _vm.options3,
          "value": row.percentage
        }
      })], 1) : _vm._e()])
    })), _vm._v(" "), (_vm.tasklisting.length == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "13",
        "align": "center"
      }
    }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()])])])])])]) : _vm._e()]
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation ",
    attrs: {
      "size": "lm",
      "title": "Assign Picker to Task"
    },
    model: {
      value: (_vm.pickerAssignmentShow),
      callback: function($$v) {
        _vm.pickerAssignmentShow = $$v
      },
      expression: "pickerAssignmentShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('activities.cycleCountUserAssignment')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.pickerAssignmentShow = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.userList')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerid),
      expression: "pickerid"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "name": "pickerid",
      "id": "userobj"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pickerid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectPicker')))]), _vm._v(" "), _vm._l((_vm.userListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)]), _vm._v(" "), (_vm.pickerid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SelectPickerErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "280px",
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.assignOrderToPicker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow fa-lg"
  }), _vm._v("\n                " + _vm._s(_vm.$t('orders.assign')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pickerAssignmentShow = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.cancelBtn')) + "\n            ")])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showadd == false) ? _c('div', [_c('div', [_c('addActivity', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent2
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showlist == false) ? _c('div', [_c('div', [_c('editActivity', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "tooltip-tarjet"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Tool Tip!"
    }
  })])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a744968", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a744968","hasScoped":true}!./src/views/components/activitylist/activitylist.component.html
// module id = 2049
// module chunks = 0